import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import VwTelediagnosistanimDTO from "src/models/TeleMedicine/VwTelediagnosistanimDTO";

export class TeleDiagnosisTanimAramaKriterleri {
    organizasyonId?: number = null;
    aciklama?: string = "";
    url?: string = "";
    islemGruplari?: string = null;
}

interface ITeleDiagnosis {
    aramaKriterleri?: TeleDiagnosisTanimAramaKriterleri;
    eklePopup?: boolean;
    activeRow?: VwTelediagnosistanimDTO;
}

const TeleDiagnosisTanimSlice = createSlice<ITeleDiagnosis, MapReducerPayloads<ITeleDiagnosis, {
    setAramaKriterleri?: TeleDiagnosisTanimAramaKriterleri;
    setEklePopup?: boolean;
    setActiveRow?: VwTelediagnosistanimDTO;
}>>({
    name: 'TeleDiagnosisTanimState',
    initialState: {
        eklePopup: false,
        aramaKriterleri: new TeleDiagnosisTanimAramaKriterleri(),
        activeRow: new VwTelediagnosistanimDTO()
    },
    reducers: {
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        setEklePopup: (state, action) => {
            state.eklePopup = action.payload
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        }
    }
});

export default TeleDiagnosisTanimSlice;